import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconEmoji: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#262626';
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.25C4.61406 0.25 0.25 4.61406 0.25 10C0.25 15.3859 4.61406 19.75 10 19.75C15.3859 19.75 19.75 15.3859 19.75 10C19.75 4.61406 15.3859 0.25 10 0.25ZM13.375 7.375C13.9984 7.375 14.5 7.87656 14.5 8.5C14.5 9.12344 13.9984 9.625 13.375 9.625C12.7516 9.625 12.25 9.12344 12.25 8.5C12.25 7.87656 12.7516 7.375 13.375 7.375ZM6.625 7.375C7.24844 7.375 7.75 7.87656 7.75 8.5C7.75 9.12344 7.24844 9.625 6.625 9.625C6.00156 9.625 5.5 9.12344 5.5 8.5C5.5 7.87656 6.00156 7.375 6.625 7.375ZM10 15.2969C7.90469 15.2969 6.14219 13.8953 5.58437 11.9828C5.51406 11.7437 5.69219 11.5 5.94531 11.5H14.05C14.2984 11.5 14.4812 11.7391 14.4109 11.9828C13.8578 13.8953 12.0953 15.2969 10 15.2969Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconEmoji;
